import { call, put } from 'redux-saga/effects'
import { getImpersonatedMemberProfile } from '../apiModules/impersonatedMemberProfiles'
import { memberProfileEntities } from '../reducks'

export function* updateImpersonatedMemberProfileEntitySaga(memberProfileId, hiringTeamId) {
  const response = yield call(getImpersonatedMemberProfile, hiringTeamId)
  yield put(memberProfileEntities.updateItem(memberProfileId, response.result))
  return response
}
